import { useState, useEffect } from 'react';

const API = 'https://tcio-api.onrender.com';

function fmtMoney(n) {
  if (!n && n !== 0) return '$0';
  const val = parseFloat(n);
  if (val >= 1000000) return '$' + (val / 1000000).toFixed(2) + 'M';
  if (val >= 1000) return '$' + (val / 1000).toFixed(1) + 'K';
  return '$' + val.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

function fmtNum(n) {
  if (!n) return '0';
  return parseInt(n).toLocaleString();
}

function cleanSource(src) {
  if (!src) return 'Unknown Source';
  return src.replace('Accounts::::', '').trim();
}

function pct(a, b) {
  if (!b || b === 0) return '—';
  return Math.round((a / b) * 100) + '%';
}

const COLORS = {
  'Journey to Solutions': '#6366f1',
  'Regrow': '#10b981',
  'Google Ads': '#f59e0b',
  'Google Adwords': '#f59e0b',
  'Alumni / Previous Patient': '#3b82f6',
  'Sales Rep / Team Member': '#8b5cf6',
  'Organic': '#14b8a6',
  'Hopeaholics': '#ec4899',
  'Referral': '#64748b',
  'Google Organic': '#0ea5e9',
  'Alli Addiction': '#f97316',
  'default': '#94a3b8',
};

function getColor(source) {
  return COLORS[source] || COLORS['default'];
}

const s = {
  page: { padding: '24px', maxWidth: '1400px', margin: '0 auto' },
  pageTitle: { fontSize: '22px', fontWeight: '700', color: '#1e293b', margin: '0 0 4px 0' },
  pageSub: { fontSize: '13px', color: '#64748b', marginBottom: '24px' },

  kpiRow: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px', marginBottom: '24px' },
  kpiCard: { background: '#fff', border: '1px solid #e2e8f0', borderRadius: '10px', padding: '16px 20px' },
  kpiLabel: { fontSize: '11px', fontWeight: '700', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '4px' },
  kpiValue: { fontSize: '24px', fontWeight: '800', color: '#1e293b' },
  kpiSub: { fontSize: '11px', color: '#94a3b8', marginTop: '2px' },

  tabRow: { display: 'flex', gap: '4px', marginBottom: '20px', borderBottom: '2px solid #e2e8f0' },
  tab: (active) => ({
    padding: '10px 20px', fontSize: '13px', fontWeight: active ? '700' : '500',
    color: active ? '#2563eb' : '#64748b', background: 'none', border: 'none',
    cursor: 'pointer', borderBottom: active ? '2px solid #2563eb' : '2px solid transparent',
    marginBottom: '-2px'
  }),

  insightRow: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px', marginBottom: '24px' },
  insightCard: { background: '#fff', border: '1px solid #e2e8f0', borderRadius: '10px', padding: '16px 20px' },
  insightTitle: { fontSize: '11px', fontWeight: '700', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '8px' },
  insightName: { fontSize: '16px', fontWeight: '700', color: '#1e293b', marginBottom: '4px' },
  insightValue: { fontSize: '20px', fontWeight: '800', color: '#15803d', marginTop: '4px' },
  insightStat: { fontSize: '12px', color: '#64748b' },

  tableCard: { background: '#fff', border: '1px solid #e2e8f0', borderRadius: '10px', overflow: 'hidden', marginBottom: '24px' },
  tableHeader: { padding: '14px 20px', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  tableTitle: { fontSize: '14px', fontWeight: '700', color: '#1e293b' },
  notice: { fontSize: '11px', color: '#94a3b8' },
  table: { width: '100%', borderCollapse: 'collapse' },
  th: { background: '#f8fafc', padding: '10px 16px', textAlign: 'left', fontSize: '11px', fontWeight: '700', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '1px solid #e2e8f0' },
  thRight: { background: '#f8fafc', padding: '10px 16px', textAlign: 'right', fontSize: '11px', fontWeight: '700', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '1px solid #e2e8f0' },
  td: { padding: '10px 16px', fontSize: '13px', color: '#334155', borderBottom: '1px solid #f1f5f9' },
  tdRight: { padding: '10px 16px', fontSize: '13px', color: '#334155', borderBottom: '1px solid #f1f5f9', textAlign: 'right' },
  tdGreen: { padding: '10px 16px', fontSize: '13px', fontWeight: '700', color: '#15803d', borderBottom: '1px solid #f1f5f9', textAlign: 'right' },
  tdBlue: { padding: '10px 16px', fontSize: '13px', fontWeight: '700', color: '#1d4ed8', borderBottom: '1px solid #f1f5f9', textAlign: 'right' },
  tdGray: { padding: '10px 16px', fontSize: '13px', color: '#94a3b8', borderBottom: '1px solid #f1f5f9', textAlign: 'right', fontStyle: 'italic' },

  sourceCell: { display: 'flex', alignItems: 'center' },
  sourceDot: (color) => ({ display: 'inline-block', width: '8px', height: '8px', borderRadius: '50%', background: color, marginRight: '8px', flexShrink: 0 }),

  verifiedBadge: { display: 'inline-block', padding: '1px 6px', borderRadius: '999px', fontSize: '10px', fontWeight: '700', background: '#dcfce7', color: '#15803d', marginLeft: '6px' },
  estBadge: { display: 'inline-block', padding: '1px 6px', borderRadius: '999px', fontSize: '10px', fontWeight: '600', background: '#f1f5f9', color: '#64748b', marginLeft: '6px' },

  barChart: { padding: '20px 24px' },
  barRow: { display: 'flex', alignItems: 'center', marginBottom: '10px', gap: '10px' },
  barLabel: { fontSize: '12px', color: '#475569', width: '200px', flexShrink: 0, textAlign: 'right' },
  barTrack: { flex: 1, background: '#f1f5f9', borderRadius: '4px', height: '22px', overflow: 'hidden' },
  barFill: (width, color, verified) => ({
    width: width + '%', height: '100%',
    background: verified ? color : color + '99',
    borderRadius: '4px', minWidth: '4px',
    display: 'flex', alignItems: 'center', paddingLeft: '8px',
  }),
  barValue: { fontSize: '11px', fontWeight: '700', color: '#fff', whiteSpace: 'nowrap' },
  barValueOutside: { fontSize: '12px', color: '#475569', marginLeft: '8px', whiteSpace: 'nowrap' },

  footerNote: { padding: '12px 20px', borderTop: '1px solid #f1f5f9', fontSize: '11px', color: '#94a3b8' },
  loadingBox: { textAlign: 'center', padding: '60px', color: '#94a3b8', fontSize: '14px' },
};

export default function ReferralROI({ user }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('overview');

  useEffect(() => {
    const token = localStorage.getItem('tcio_token');
    fetch(`${API}/api/referral-roi`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json())
      .then(d => { if (d.ok) setData(d.data); })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={s.loadingBox}>Loading referral intelligence...</div>;
  if (!data) return <div style={s.loadingBox}>No data available.</div>;

  const { bySource, totalAdmits, totalLeads, totalVerifiedRevenue, totalEstimatedRevenue, avgRevenuePerPatient, topByEstimated, topConverters, highestLOS } = data;

  const maxAdmits = Math.max(...bySource.map(r => parseInt(r.admits || 0)));
  const maxEst = Math.max(...bySource.map(r => r.estimated_revenue || 0));

  return (
    <div style={s.page}>
      <div style={s.pageTitle}>Referral Source Intelligence</div>
      <div style={s.pageSub}>Which marketing channels and referral partners generate revenue — {fmtMoney(avgRevenuePerPatient)} average collected per admit</div>

      {/* KPI Banner */}
      <div style={s.kpiRow}>
        <div style={s.kpiCard}>
          <div style={s.kpiLabel}>Estimated Total Revenue</div>
          <div style={s.kpiValue}>{fmtMoney(totalEstimatedRevenue)}</div>
          <div style={s.kpiSub}>admits × ${Math.round(avgRevenuePerPatient / 1000)}K avg</div>
        </div>
        <div style={s.kpiCard}>
          <div style={s.kpiLabel}>Total Admits</div>
          <div style={s.kpiValue}>{fmtNum(totalAdmits)}</div>
          <div style={s.kpiSub}>from historical records</div>
        </div>
        <div style={s.kpiCard}>
          <div style={s.kpiLabel}>Total Leads</div>
          <div style={s.kpiValue}>{fmtNum(totalLeads)}</div>
          <div style={s.kpiSub}>across all sources</div>
        </div>
        <div style={s.kpiCard}>
          <div style={s.kpiLabel}>Overall Close Rate</div>
          <div style={s.kpiValue}>{pct(totalAdmits, totalLeads)}</div>
          <div style={s.kpiSub}>leads → admits</div>
        </div>
      </div>

      {/* Insight Cards */}
      <div style={s.insightRow}>
        <div style={s.insightCard}>
          <div style={s.insightTitle}>🏆 Highest Volume Source</div>
          <div style={s.insightName}>{cleanSource(topByEstimated?.source)}</div>
          <div style={s.insightValue}>{fmtMoney(topByEstimated?.estimated_revenue)}</div>
          <div style={s.insightStat}>{fmtNum(topByEstimated?.admits)} admits · estimated</div>
        </div>
        <div style={s.insightCard}>
          <div style={s.insightTitle}>🎯 Best Close Rate</div>
          <div style={s.insightName}>{cleanSource(topConverters?.source)}</div>
          <div style={s.insightValue}>{topConverters?.close_rate}%</div>
          <div style={s.insightStat}>{fmtNum(topConverters?.admits)} admits from {fmtNum(topConverters?.total_leads)} leads</div>
        </div>
        <div style={s.insightCard}>
          <div style={s.insightTitle}>📅 Longest Average LOS</div>
          <div style={s.insightName}>{cleanSource(highestLOS?.source)}</div>
          <div style={s.insightValue}>{parseFloat(highestLOS?.avg_los || 0).toFixed(0)} days</div>
          <div style={s.insightStat}>{fmtNum(highestLOS?.admits)} admits</div>
        </div>
      </div>

      {/* Tabs */}
      <div style={s.tabRow}>
        <button style={s.tab(activeTab === 'overview')} onClick={() => setActiveTab('overview')}>Overview Table</button>
        <button style={s.tab(activeTab === 'admits')} onClick={() => setActiveTab('admits')}>Admits by Source</button>
        <button style={s.tab(activeTab === 'revenue')} onClick={() => setActiveTab('revenue')}>Revenue by Source</button>
        <button style={s.tab(activeTab === 'partners')} onClick={() => setActiveTab('partners')}>Referral Partners</button>
      </div>

      {/* Overview Table */}
      {activeTab === 'overview' && (
        <div style={s.tableCard}>
          <div style={s.tableHeader}>
            <div style={s.tableTitle}>All Sources — Leads → Admits → Revenue</div>
            <div style={s.notice}>✅ Verified = member ID matched &nbsp;·&nbsp; ~ Estimated = admits × $18.5K avg</div>
          </div>
          <table style={s.table}>
            <thead>
              <tr>
                <th style={s.th}>Source</th>
                <th style={s.thRight}>Leads</th>
                <th style={s.thRight}>Admits</th>
                <th style={s.thRight}>Close Rate</th>
                <th style={s.thRight}>Avg LOS</th>
                <th style={s.thRight}>Revenue</th>
                <th style={s.thRight}>Rev / Admit</th>
              </tr>
            </thead>
            <tbody>
              {bySource.map((row, i) => {
                const admits = parseInt(row.admits || 0);
                const revenue = row.revenue_verified ? row.total_collected : row.estimated_revenue;
                const revPerAdmit = admits > 0 ? revenue / admits : null;
                const verified = row.revenue_verified;
                return (
                  <tr key={i}
                    onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
                    onMouseLeave={e => e.currentTarget.style.background = ''}>
                    <td style={s.td}>
                      <div style={s.sourceCell}>
                        <span style={s.sourceDot(getColor(row.source))} />
                        {cleanSource(row.source)}
                        {verified
                          ? <span style={s.verifiedBadge}>✓ verified</span>
                          : <span style={s.estBadge}>~ est</span>}
                      </div>
                    </td>
                    <td style={s.tdRight}>{fmtNum(row.total_leads)}</td>
                    <td style={s.tdRight}>{fmtNum(admits)}</td>
                    <td style={s.tdRight}>{pct(admits, row.total_leads)}</td>
                    <td style={s.tdRight}>{row.avg_los ? parseFloat(row.avg_los).toFixed(0) + 'd' : '—'}</td>
                    <td style={verified ? s.tdGreen : s.tdGray}>{fmtMoney(revenue)}</td>
                    <td style={verified ? s.tdBlue : s.tdGray}>{revPerAdmit ? fmtMoney(revPerAdmit) : '—'}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <div style={s.footerNote}>
            ~ Estimated revenue = admits × $18,503 average collected per patient across all 95,135 paid claims. Verified revenue requires member ID match in Dazos.
          </div>
        </div>
      )}

      {/* Admits Bar Chart */}
      {activeTab === 'admits' && (
        <div style={s.tableCard}>
          <div style={s.tableHeader}>
            <div style={s.tableTitle}>Admits by Source</div>
          </div>
          <div style={s.barChart}>
            {bySource.filter(r => parseInt(r.admits) > 0).slice(0, 15).map((row, i) => {
              const admits = parseInt(row.admits || 0);
              return (
                <div key={i} style={s.barRow}>
                  <div style={s.barLabel}>{cleanSource(row.source)}</div>
                  <div style={s.barTrack}>
                    <div style={s.barFill(Math.round((admits / maxAdmits) * 100), getColor(row.source), true)}>
                      {admits > maxAdmits * 0.15 && <span style={s.barValue}>{fmtNum(admits)}</span>}
                    </div>
                  </div>
                  {admits <= maxAdmits * 0.15 && <span style={s.barValueOutside}>{fmtNum(admits)}</span>}
                  <span style={{ fontSize: '11px', color: '#94a3b8', width: '45px', textAlign: 'right' }}>
                    {pct(admits, row.total_leads)}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Revenue Bar Chart */}
      {activeTab === 'revenue' && (
        <div style={s.tableCard}>
          <div style={s.tableHeader}>
            <div style={s.tableTitle}>Estimated Revenue by Source</div>
            <div style={s.notice}>Solid = verified · Faded = estimated</div>
          </div>
          <div style={s.barChart}>
            {bySource.filter(r => parseInt(r.admits) > 0).slice(0, 15).map((row, i) => {
              const rev = row.revenue_verified ? parseFloat(row.total_collected) : row.estimated_revenue;
              return (
                <div key={i} style={s.barRow}>
                  <div style={s.barLabel}>{cleanSource(row.source)}</div>
                  <div style={s.barTrack}>
                    <div style={s.barFill(Math.round((rev / maxEst) * 100), getColor(row.source), row.revenue_verified)}>
                      {rev > maxEst * 0.15 && <span style={s.barValue}>{fmtMoney(rev)}</span>}
                    </div>
                  </div>
                  {rev <= maxEst * 0.15 && <span style={s.barValueOutside}>{fmtMoney(rev)}</span>}
                  {row.revenue_verified && <span style={{ fontSize: '10px', color: '#15803d', fontWeight: '700' }}>✓</span>}
                </div>
              );
            })}
          </div>
          <div style={s.footerNote}>
            ~ Estimated = admits × $18,503 avg. ✓ Verified = member ID matched paid claims.
          </div>
        </div>
      )}

      {/* Referral Partners */}
      {activeTab === 'partners' && (
        <div style={s.tableCard}>
          <div style={s.tableHeader}>
            <div style={s.tableTitle}>B2B Referral Partners — Verified Revenue</div>
            <div style={s.notice}>Member ID matched only</div>
          </div>
          <table style={s.table}>
            <thead>
              <tr>
                <th style={s.th}>Partner</th>
                <th style={s.thRight}>Patients</th>
                <th style={s.thRight}>Verified Revenue</th>
                <th style={s.thRight}>Avg per Patient</th>
              </tr>
            </thead>
            <tbody>
              {bySource.filter(r => r.source && r.source.includes('Accounts::::') && r.revenue_verified).map((row, i) => {
                const avg = row.patients > 0 ? parseFloat(row.total_collected) / row.patients : 0;
                return (
                  <tr key={i}
                    onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
                    onMouseLeave={e => e.currentTarget.style.background = ''}>
                    <td style={s.td}>{cleanSource(row.source)}</td>
                    <td style={s.tdRight}>{fmtNum(row.patients)}</td>
                    <td style={s.tdGreen}>{fmtMoney(row.total_collected)}</td>
                    <td style={s.tdBlue}>{fmtMoney(avg)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}